<script setup lang="ts">
import SuperJSON from 'superjson';
import type { IgMediaItem } from '~~/src/core/types';

const { status, data: posts } = await useFetch('/api/instagram/feed', {
  lazy: true,
  default: () => [],
  transform(payload) {
    return SuperJSON.deserialize<IgMediaItem[]>(payload);
  },
});

const text = {
  title: 'Sleduj nás na instagramu',
  error: 'Nastala chyba při načítání příspěvků',
  link: 'Přejít na instagram',
  loading: 'Načítám...',
} as const;
</script>

<template>
  <PageContainerAlignment
    as="section"
    class="py-r12 lg:py-r18 gap-r4 lg:gap-r16 flex flex-col overflow-hidden"
  >
    <AppHeading tag="h2" class="text-client-black lg:text-center">
      {{ text.title }}
    </AppHeading>
    <div class="gap-r4 lg:gap-r16 flex flex-col items-center">
      <div class="w-full">
        <template v-if="status === 'pending' || status === 'success'">
          <FeedPostContainer
            :loading="status === 'pending'"
            :posts
            class="max-lg:hidden"
          />
          <AppParagraph
            v-if="status === 'pending'"
            class="text-client-black text-center"
          >
            {{ text.loading }}
          </AppParagraph>
          <FeedPostContainerMobile v-else :posts class="lg:hidden" />
        </template>
        <AppParagraph
          v-else-if="status === 'error'"
          class="text-client-black text-center"
        >
          {{ text.error }}
        </AppParagraph>
      </div>
      <AppLink
        type="button"
        to="https://www.instagram.com/okgym.cz/"
        :opts="{ link: { external: true, target: '_blank' } }"
      >
        {{ text.link }}

        <template #icon>
          <AppIcon name="icon:instagram" size="sm" />
        </template>
      </AppLink>
    </div>
  </PageContainerAlignment>
</template>
